export const ATTRIBUTE_CONTENTEDITABLE_NAME = 'contenteditable';
